import { customElement, DeesElement, property, html, TemplateResult, css, cssManager } from '@designestate/dees-element';

import * as domtools from '@designestate/dees-domtools';

import * as lointReception from '@losslessone_private/loint-reception';

import '@designestate/dees-catalog';

@customElement('lele-usergate')
export class LeleUsergate extends DeesElement {
  public static demo = () => html`<lele-usergate></lele-usergate>`;

  @property()
  public activePane: 'login' | 'register' = 'login';

  constructor() {
    super();
    domtools.elementBasic.setup();
  }

  public render(): TemplateResult {
    return html`
      ${domtools.elementBasic.styles}
      <style>
        :host {
          display: block;
          max-width: 520px;
          padding: 50px;
          margin-left: auto;
          margin-right: auto;
          color: #ffffff;
        }
      </style>
      <div class="loginbox box ${this.activePane === 'login' ? 'active' : ''}">
        <div
          class="boxheading"
          @click="${() => {
            this.activePane = 'login';
          }}"
        >
          Login
        </div>
        <div class="boxcontent">
          <dees-form>
            <dees-input-text key="username" label="Username"></dees-input-text>
            <dees-input-text key="password" label="Password"></dees-input-text>
            <dees-form-submit>Send magic link (or enter password)</dees-form-submit>
          </dees-form>
        </div>
      </div>
      <div class="registerbox box ${this.activePane === 'register' ? 'active' : ''}">
        <div
          class="boxheading "
          @click="${() => {
            this.activePane = 'register';
          }}"
        >
          Register
        </div>
        <div class="boxcontent">
          <dees-form>
            <dees-input-text key="email" label="Email-Address"></dees-input-text>
            <dees-form-submit>Send Verification Email </dees-form-submit>
          </dees-form>
        </div>
      </div>
    `;
  }
}
